import React, { useState } from 'react';
import Button from '../../../components/ui/Button';

import { cn } from '../../../utils/cn';

const CalculationCard = ({ calculation, onDelete, onDuplicate, isSelected, onSelect }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleDelete = () => {
    if (showDeleteConfirm) {
      onDelete(calculation?.id);
    } else {
      setShowDeleteConfirm(true);
      setTimeout(() => setShowDeleteConfirm(false), 3000);
    }
  };

  return (
    <div
      className={cn(
        "p-5 rounded-xl border-2 transition-all duration-200 hover:shadow-[0_0_20px_rgba(0,212,255,0.15)]",
        isSelected
          ? "border-primary bg-primary/5" :"border-border bg-card hover:border-primary/50"
      )}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-start gap-3 flex-1">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => onSelect(e?.target?.checked)}
            className="mt-1 h-4 w-4 rounded border-input bg-background text-primary focus:ring-2 focus:ring-ring"
          />
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-1 line-clamp-2">
              {calculation?.title}
            </h3>
            <p className="text-sm text-muted-foreground">
              {formatDate(calculation?.date)}
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3 mb-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Syringe Volume:</span>
          <span className="font-medium text-foreground">{calculation?.syringeVolume} units</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Peptides:</span>
          <span className="font-medium text-foreground">
            {calculation?.peptides?.filter(p => p?.quantity)?.length}
          </span>
        </div>
        {calculation?.result && (
          <div className="p-3 rounded-lg bg-primary/10 border border-primary/20">
            <p className="text-sm font-medium text-foreground text-center">
              Draw <span className="text-primary">{calculation?.result?.unitsPerDose} units</span> for{' '}
              <span className="text-accent">{calculation?.result?.doseValue}{calculation?.result?.doseUnit}</span>
            </p>
          </div>
        )}
      </div>

      {isExpanded && (
        <div className="mb-4 p-4 rounded-lg bg-muted/50 border border-border space-y-3">
          <div>
            <p className="text-xs font-semibold text-muted-foreground mb-2">PEPTIDES</p>
            {calculation?.peptides?.filter(p => p?.quantity)?.map((peptide) => (
              <div key={peptide?.id} className="flex justify-between text-sm mb-1">
                <span className="text-foreground">{peptide?.name}</span>
                <span className="font-medium text-foreground">{peptide?.quantity} mg</span>
              </div>
            ))}
          </div>
          <div>
            <p className="text-xs font-semibold text-muted-foreground mb-1">WATER VOLUME</p>
            <p className="text-sm text-foreground">
              {calculation?.waterVolume?.value} {calculation?.waterVolume?.unit}
            </p>
          </div>
          {calculation?.result && (
            <div>
              <p className="text-xs font-semibold text-muted-foreground mb-1">CONCENTRATION</p>
              <p className="text-sm text-foreground">{calculation?.result?.concentration} mg/mL</p>
            </div>
          )}
          {calculation?.notes && (
            <div>
              <p className="text-xs font-semibold text-muted-foreground mb-1">NOTES</p>
              <p className="text-sm text-muted-foreground">{calculation?.notes}</p>
            </div>
          )}
        </div>
      )}

      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          fullWidth
          onClick={() => setIsExpanded(!isExpanded)}
          iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
        >
          {isExpanded ? 'Less' : 'More'}
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onDuplicate(calculation)}
          iconName="Copy"
          className="hover:bg-primary/10 hover:text-primary"
        />
        <Button
          variant="ghost"
          size="sm"
          onClick={handleDelete}
          iconName="Trash2"
          className={cn(
            "hover:bg-error/10 hover:text-error",
            showDeleteConfirm && "bg-error/20 text-error"
          )}
        >
          {showDeleteConfirm ? 'Confirm?' : ''}
        </Button>
      </div>
    </div>
  );
};

export default CalculationCard;